export default function isSmallMobile() {
  return window.innerHeight < 720 && window.innerWidth < 500;
}
